<template>
  <div class="history_person_pages">
    <div class="search_filed">
      <input type="text" placeholder="输入姓名或手机号进行搜索" v-model="search" v-on:keyup.enter="searchList" />
    </div>
    <div class="user_list">
      <div class="user" v-for="(item,index) in list" :key="index" @click="selectUser(item)">
        <div class="flex1 user_top">
          <div class="flex2">
            <img src="@/images/user_man.png" class="user_img" v-if="item.Sex==1" />
            <img src="@/images/user_woman.png" class="user_img" v-if="item.Sex==2" />
            <span class="name">{{item.Name}}</span>
            <span class="sex">{{item.Sex==1?"男":"女"}}/</span>
            <span class="age">{{item.Age}}</span>
          </div>
        
          <div>{{item.Mobilephone}}</div>
        </div>
        <div class="count">问诊次数：{{item.Inquirycount}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetPatientList, GetPatient } from "@/utils/api";
import { Toast } from "vant";
export default {
  data() {
    return {
      search: "",
      list: [],
      pageIndex:1
    };
  },
  methods: {
    //   搜索框搜索
      searchList(){
          this.pageIndex = 1
          this.list= []
          this.getPatientList()
      },
    //   选中历史用药人
    selectUser(item) {
      console.log(item);
      GetPatient({ patientId: item.PatientId }).then(res => {
        if (res.code == 1) {
          let data = res.data;
          let fillData = JSON.parse(sessionStorage.getItem("fillData"));
          console.log(fillData);
          fillData.PatientId = data.PatientId;
          fillData.currentDate = data.Birthday;

          fillData.person[0].text = data.Name;
          fillData.person[1].text = data.IDCard;
          fillData.person[2].text =
            new Date(data.Birthday).getFullYear() +
            "-" +
            String(new Date(data.Birthday).getMonth() + 1).padStart(2, "0");
          fillData.person[3].text = data.Sex == 1 ? "男" : "女";
          fillData.person[4].text = data.Mobilephone;
          fillData.person[5].testList[0].name = data.PMHDesc;
          fillData.person[5].testList[1].name = data.AMHDesc;
          fillData.person[5].testList[2].name = data.FMHDesc;
          fillData.person[5].testList[3].name = data.NurseDesc;
          fillData.person[5].testList[4].name = data.LiverDesc;
          fillData.person[5].testList[5].name = data.RenalDesc;

          fillData.hsitoryDisList[0].radio = data.PMHType;
          fillData.hsitoryDisList[1].radio = data.AMHType;
          fillData.hsitoryDisList[2].radio = data.FMHType;
          fillData.hsitoryDisList[3].radio = data.NurseType;
          fillData.hsitoryDisList[4].radio = data.LiverType;
          fillData.hsitoryDisList[5].radio = data.RenalType;

          fillData.weight = data.Weight;

          let str = "";
          fillData.hsitoryDisList.map((item, index) => {
            if (item.radio == 1) {
                
              if (index == 4 || index == 5) {
                  // 判断肝肾功能是否异常
                str += item.name + "异常、";
              } else {
                //   debugger
                str += "有" + item.name + "、";
              }
            }
          });
          if (str == "") {
            fillData.person[5].text = "无";
          } else {
            fillData.person[5].text = str.substring(0, str.length - 1);
          }

          fillData.hsitoryDisList.map((item, index) => {
            //   debugger
            let temArr = [];
            let arr = fillData.person[5].testList[index].name.split("、");
            item.medList.map((it, inx) => {
              arr.map((items, indexs) => {
                if (items == it.name) {
                  it.sel = true;
                }
              });
            });
            if(item.name=="肝功能"||item.name=="肾功能")return
            // 判断返回的值是否存在不是系统默认的值
            arr.map((items, indexs) => {
              let count = item.medList.every((it, inx) => {
                return items != it.name;
              });
              if (count) {
                temArr.push({
                  sys: false,
                  sel: true,
                  name: items
                });
                temArr.map(items3 => {
                  if (items3.name) {
                    item.medList.push(items3);
                  }
                });
              }
            });
          });
          if(data.Sex==1){
            // debugger
            fillData.hsitoryDisList[3].medList = [],
            fillData.hsitoryDisList[3].name = "备孕中"
            fillData.person[5].testList[3].title ="备孕中"
          }else{
            fillData.hsitoryDisList[3].name = "妊娠哺乳";
            fillData.hsitoryDisList[3].medList = [
              { name: "备孕中", sel: false, sys: true },
              { name: "怀孕中", sel: false, sys: true },
              { name: "正在哺乳", sel: false, sys: true }
          ];
            if(data.NurseDesc){
              fillData.hsitoryDisList[3].medList.map(item=>{
                if(item.name==data.NurseDesc){
                  item.sel = true
                }
              })
            }
          }
          console.log(fillData);
          
          sessionStorage.setItem("fillData", JSON.stringify(fillData));
          sessionStorage.removeItem("firstHis");
          sessionStorage.setItem('his_people','true')
          this.$router.back(-1)
        } else {
          Toast(res.msg);
        }
      });
    },
    getPatientList() {
      let data = {
        Search: this.search,
        pageIndex: this.pageIndex,
        pageSize: 100
      };
      GetPatientList(data).then(res => {
        console.log(res);
        if (res.code == 1) {
          res.data.list.map(item => {
            // item.Age = new Date((new Date(item.CreateDate).getTime()-new Date(item.Birthday).getTime())).getFullYear()
          });
          this.list = res.data != null ? [...this.list, ...res.data.list] : [];
          this.pageIndex +=1
        }
      });
    }
  },
  mounted() {
    console.log(this.$router);
    
    this.getPatientList();
  }
};
</script>

<style lang="scss" scoped>

.history_person_pages {
  padding-top: 20px;
  .search_filed {
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
    // position: fixed;
    // top: 20px;
    input {
      -webkit-appearance: none;
      outline: none;
      width: 80%;
      height: 34px;
      border-radius: 15px;
      padding: 0 10px;
      text-align: center;
      border: 1px solid #e4e4e4;
    }
  }
  .user_list {
    width: 85%;
    margin: 0 auto;
    .user {
      width: 100%;
      border-radius: 12px;
      box-shadow: 0px 4px 5px rgba(215, 215, 215, 0.349019607843137);
      border: 1px solid rgba(242, 242, 242, 1);
      margin-bottom: 20px;
      .user_top {
        border-bottom: 1px solid rgba(242, 242, 242, 1);
        width: 90%;
        margin: 0 auto;
        padding: 10px 0;
        .user_img {
          width: 40px;
          height: 40px;
          margin-right: 15px;
          flex: 0 0 auto;
        }
        .name {
          font-size: 16px;
          font-weight: bold;
          max-width: 90px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .sex {
          font-size: 15px;
          color: #666666;
          margin-left: 10px;
        }
        .age {
          font-size: 15px;
          color: #666666;
        }
      }
      .count {
        padding: 10px 0;
        width: 90%;
        margin: 0 auto;
        color: #666666;
      }
    }
  }
}
</style>
